export enum ERROR_CODE {
    EMAIL_DOMAIN_NOT_FOUND = 'email_domain_not_found',
    MEMBER_INACTIVE = 'member_inactive',
    MEMBER_ACTIVE_IN_FUTURE = 'member_active_in_future',
    PIN_LIMIT_REACHED = 'pin_limit_reached',
    INVALID_ACCESS_CODE = 'invalid_access_code',
    // The access code could not be checked at all (no circle to check it
    // against), as opposed to being checked and rejected.
    ACCESS_CODE_CHECK_UNAVAILABLE = 'access_code_check_unavailable',
    INVALID_SPONSOR_CODE = 'invalid_sponsor_code',
    ELIGIBILITY_FIELDS_VALIDATION_ERROR = 'eligibility_fields_validation_error',
    CONTRACT_COVERED_LIVES_EXCEEDED = 'contract_covered_lives_exceeded',
    MEMBER_ELIGIBILITY_USED = 'member_eligibility_used',
    TRANSITION_PARTNER_NOT_FOUND = 'transition_partner_not_found',
    UPGRADE_INTERNATIONAL_USER_NOT_ALLOWED_FOR_DOMESTIC_PARTNER = 'upgrade_international_user_not_allowed_for_domestic_partner',
    UPGRADE_UNEXPECTED_INTERNATIONAL_USER = 'upgrade_unexpected_international_user',
    INVALID_ACTIVATION_TOKEN = 'invalid_activation_token',
    ACTIVATION_TOKEN_PARTNER_MISMATCH = 'activation_token_partner_mismatch',
    TOO_MANY_PLAYLISTS = 'too_many_playlists',
    PLAYLIST_FULL = 'playlist_full',
}

export const InvalidCountryErrorCode = 'unsupported_country_code';

export const UnderageErrorCode = 'age_restricted_for_country';
